import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { deleteCampaign, fetchCampaignByUUID } from "../../services/campaign.service";
import {Avatar, Button, Card, Col, Descriptions, List, Row, Spin, Steps, Table, Timeline, Typography} from "antd";
import {  MenuUnfoldOutlined, CalendarOutlined } from "@ant-design/icons";
import { getCampaignProgress, getStateNameById } from "./utils";
import {getFormattedDate, noAccess} from "../../utils/common";
import { fetchAllInterviewByCampaignId } from "../../services/interview.service";
import { GlobalContext } from "../../context/GlobalContext";
import userFemaleIcon from "../../assets/images/female.png";
import { showSuccessMessage } from "../../utils/notification.util";
import DeleteItemModal from "../../components/layout/DeleteItemModal";
import Interview from "../Interview";
import {roleValues} from "../../config/roles";

const { Title, Text } = Typography;

export const CampaignDetail = () => {
  const [loading, setLoading] = useState(true);
  const { setBreadCrumb, user } = useContext(GlobalContext);
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState({
    id: '',
    uuid: "",
    name: "",
    description: "",
    phase: "",
    startDate: "",
    endDate: "",
    createdBy:{},
    createdAt: "",
  });
  const [interviews, setInterviews] = useState([]);
  useEffect(() => {
    fetchCampaignByUUID(uuid)
    .then((response) => {
      if(!response.data) {
        window.location.href = '/location';
      }
      setCampaign(response.data);
      setBreadCrumb([
        {
          title: 'Survivor Identification',
          link: '/location',
        },
        {
          title: getStateNameById(response.data.state) + ', ' + response.data.district,
          link: `/location/detail/${uuid}`,
        },
      ]);
      if(user?.role === roleValues.dataProtectionOfficer || user?.role === roleValues.projectCoordinator) {
        if (user?.district !== response.data.district) {
          noAccess();
        }
      }
      fetchAllInterviewByCampaignId(response.data.id)
      .then((response) => {
        setInterviews(response.data);
      })
      .catch((error) => {
        console.log(error)
      })
          .finally(() => {setLoading(false)});
    })
    .catch((error) => {
      console.log(error)
    });
  }, []);
  const deleteRecord = () => {
    deleteCampaign(uuid)
      .then(() => {
        showSuccessMessage("Record deleted successfully");
        navigate(`/location`);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  return (
    <>
      <Spin spinning={loading}>
        <Row gutter={[24, 0]}>
          <Col xs={24} md={24}>
            <Row gutter={[24, 0]}>
              <Col xs={24} className="mb-24">
                <Card
                  className="header-solid h-full ant-card-p-0"
                  title={
                    <Row
                        gutter={[24, 0]}
                        className="ant-row-flex ant-row-flex-middle"
                      >
                        <Col xs={24} md={12}>
                          <h2 className="font-semibold m-0">{campaign?.district}, {getStateNameById(campaign?.state)}</h2>
                        </Col>
                        <Col xs={24} md={12} className="d-flex">
                          {user.role === roleValues.admin && <NavLink to={`/location/edit/${campaign?.uuid}`}>Edit</NavLink>}
                        </Col>
                      </Row>
                  }
                >
                  <Row gutter={[24, 0]}>
                    <Col span={24} md={24}>
                    {campaign.description}
                    </Col>
                  </Row>
                  <Row gutter={[24, 0]} style={{marginTop: "20px"}}>
                    <Col span={24} md={24}>
                      <i>Created by: {campaign?.createdBy?.fullName || 'N/A'}, {getFormattedDate(campaign.createdAt, 'MMMM DD, YYYY')}</i>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={[24, 0]}>
          <Col span={24} md={18} className="mb-24">
              {/* <Row gutter={[24, 24]}>
                  <Col span={24}>
                    <Card
                        bordered={false}
                        title={<Row gutter={[24, 0]}>
                          <Col xs={24} md={19}><h2 className="font-semibold m-0">Survivors ({interviews.length})</h2></Col>
                          <Col xs={24} md={5}>
                          <Button
                            type="default"
                            onClick={() => navigate(`/location/${campaign.uuid}/interview/create`)}
                          >
                            Add New Survivor
                          </Button>
                          </Col>
                        </Row>}
                        className="header-solid h-full"
                        bodyStyle={{ paddingTop: 0, paddingBottom: 16 }}
                      >
                        <hr/>
                        <List
                          itemLayout="horizontal"
                          dataSource={interviews}
                          split={false}
                          className="conversations-list"
                          renderItem={(item) => (
                            <List.Item actions={[<NavLink to={`/location/${campaign.uuid}/interview/detail/${item.uuid}`}>VIEW</NavLink>]}>
                              <List.Item.Meta
                                avatar={
                                  <Avatar shape="square" size={48} src={userFemaleIcon} />
                                }
                                title={(<NavLink to={`/location/${campaign.uuid}/interview/detail/${item.uuid}`}><Text>{item.basicInfo.fullName} ({item.basicInfo.personalCode}), {item.basicInfo.age}</Text></NavLink>)}
                                description={(<>
                                  <div>{item.basicInfo.address}, {item.basicInfo.contactNumber}</div>
                                  <i>Date: {getFormattedDate(item.createdAt, 'MMMM DD, YYYY')}, created by: {item.createdBy.fullName}</i>
                                </>)}
                              />
                            </List.Item>
                          )}
                        />
                      </Card>
                  </Col>
              </Row> */}
              {campaign?.id && <Interview campaignID={campaign.id} campaignUUID={campaign.uuid}/>}
          </Col>
          <Col span={24} md={6} className="mb-24">
            <Card
              bordered={false}
              className="header-solid h-full  ant-list-yes"
              title={<h6 className="font-semibold m-0">Additional Details</h6>}
            >
              <List
                header={<h6>Dates</h6>}
                className="transactions-list ant-newest"
                itemLayout="horizontal"
                dataSource={[{date: campaign.startDate, title: "Start Date"}, {date: campaign.endDate, title: "End Date"}]}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={
                        <Avatar size="small" className='text-fill'>
                          <CalendarOutlined style={{ fontSize: 10 }} />
                        </Avatar>
                      }
                      title={item.title}
                      description={getFormattedDate(item.date, 'MMMM DD, YYYY')}
                    />
                  </List.Item>
                )}
              />
              <div className="timeline-box">
              <br/>
                  <h6>Phase</h6>
                  <br/>
                  <Timeline
                    // pending="Recording..."
                    className="timelinelist"
                    reverse={false}
                  >
                    {getCampaignProgress(campaign.phase).map((t, index) => (
                      <Timeline.Item color={t.color} key={index}>
                        <Title level={5}>{t.value}</Title>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                  {/* <Button
                    type="primary"
                    className="width-100"
                    onClick={() => navigate(`/location/${campaign.uuid}/interview/create`)}
                  >
                    {<MenuUnfoldOutlined />} Submit New Interview
                  </Button> */}
                  {/* <Button
                    type="primary"
                    className="width-100"
                    onClick={() => deleteRecord()}
                  >
                    Delete all
                  </Button> */}
                </div>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{textAlign: "right"}}>
          <DeleteItemModal onDelete={deleteRecord} item={''} buttonType={'default'} text={'Delete All'}/>
          </Col>
        </Row>
      </Spin>
    </>
  )
};
